\rentware-radio
    width: 100%
    height: 100%

\svg
    flex-shrink: 0

//noinspection CssNoGenericFontName
.RadioContainer
    width: 100%
    height: 100%
    min-width: 250px
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center
    font-size: 14px
    -webkit-user-select: none
    -moz-user-select: none
    -ms-user-select: none
    user-select: none
    box-sizing: border-box
    cursor: pointer
    color: rgb($globalSettingsFontSecondary)
.RadioContainer:hover
    color: rgb($globalSettingsFontPrimary)
.RadioContainer.RadioContainerDisabled
    &:hover
        color: rgb($globalSettingsFontSecondary)
        cursor: default

.RadioContainer input
    position: absolute
    opacity: 0
    height: 0
    width: 0
    z-index: -1

.RadioField
    width: 16px
    height: 16px
    border: 2px solid rgb($globalSettingsStrokeSecondary)
    margin: 2px
    border-radius: 50%
    display: flex
    align-items: center
    justify-content: center
    flex-shrink: 0
    stroke: rgb($globalSettingsBackgroundPrimary)
    stroke-opacity: 0
    fill: rgb($globalSettingsStrokeSecondary)
.RadioContainer:hover input ~ .RadioField
    border: 2px solid rgb($globalSettingsStrokePrimary)

.Selected
    font-weight: 700

.RadioContainer input:checked ~ .RadioField
    width: 20px
    height: 20px
    margin: 0
    border: none
    border-radius: 50%
    background: rgb($globalSettingsFontSecondary)
    stroke-opacity: 1
    fill: rgb($globalSettingsBackgroundPrimary)

.RadioContainer:hover input:checked ~ .RadioField
    background: rgb($globalSettingsFontPrimary)

.RadioContainer input:disabled ~ .RadioField
    border: 2px solid rgb($globalSettingsStrokeTertiary)
    cursor: default
.RadioContainer:hover input:disabled ~ .RadioField
    border: 2px solid rgb($globalSettingsStrokeTertiary)

.ContainerError
    color: rgb($globalErrorBackground) !important

.RadioContainer input ~ .Error
    border: 2px solid rgb($globalErrorBackground) !important

.RadioContainer input:checked ~ .Error
    background: rgb($globalErrorBackground) !important

.Label
    margin-left: 10px
    width: 100%
    box-sizing: border-box
    display: flex
    flex-direction: row-reverse
    align-items: flex-end
    justify-content: space-between
